/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Profile_Connections_HintInputs */

const cs_settings_profile_connections_hint = /** @type {(inputs: Settings_Profile_Connections_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toto je jen vaše. Firemní klíče Sreality RK a katastr zůstávají v Integracích — i v jednomakléřské kanceláři.`)
};

const en_settings_profile_connections_hint = /** @type {(inputs: Settings_Profile_Connections_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`These are yours alone. Office Sreality RK keys and cadastre stay under Integrations — even in a one-person office.`)
};

/**
* | output |
* | --- |
* | "These are yours alone. Office Sreality RK keys and cadastre stay under Integrations — even in a one-person office." |
*
* @param {Settings_Profile_Connections_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_profile_connections_hint = /** @type {((inputs?: Settings_Profile_Connections_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Profile_Connections_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_profile_connections_hint(inputs)
	return cs_settings_profile_connections_hint(inputs)
});